import { englishValidationMessage } from "./messages-en"
import { mexicanSpanishValidationMessage } from "./messages-es-mx"

const userLanguage = navigator.language || navigator.userLanguage

const getMessages = () => {
    if (userLanguage.startsWith("es")) return mexicanSpanishValidationMessage
    else if (userLanguage.startsWith("en")) return englishValidationMessage
    else return englishValidationMessage
}

export const ValidationMessage = getMessages()

export default ValidationMessage
